import { render, staticRenderFns } from "./CardUploadResult.vue?vue&type=template&id=0df5603e&"
import script from "./CardUploadResult.vue?vue&type=script&lang=ts&"
export * from "./CardUploadResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports